import { FunctionComponent } from 'react'
import { usePlatformConfig } from '@dxp-module/common'
import MiniMyAccountInitializer from './MiniMyAccountInitializer'

/**
 * This component will start mini-myAccount
 */
const MiniMyAccountComponent: FunctionComponent = () => {
  const {
    platformConfig: { myAccount },
  } = usePlatformConfig()

  return myAccount?.miniMyAccountConfig ? <MiniMyAccountInitializer /> : null
}

export default MiniMyAccountComponent
